// extracted by mini-css-extract-plugin
module.exports = {"table":"table-project_table__3Ozfn","loading":"table-project_loading__2ZxLp"};